<form [formGroup]="form" class="row">
	<mat-form-field class="col">
		<mat-label>{{label.length > 0 ? label : 'Select Grade' + (isMultiple ? '(s)' : '')}}
		</mat-label>
		<mat-select formControlName="gradeSelect" [multiple]="isMultiple" [panelClass]="'panel-location-region'"
			[required]="required" (selectionChange)="selectGrade($event.value)">
			<mat-select-trigger>
				{{gradesFlat}}
			</mat-select-trigger>

			<div class="padding-md text-center row gx-0">
				<div class="col" *ngIf="isMultiple">
					<button color="primary" mat-raised-button (click)="selectAll()">
						Select All
					</button>
				</div>
				<div class="text-center col">
					<button color="accent" mat-raised-button (click)="deSelectAll()">
						Deselect <span *ngIf="isMultiple">All</span>
					</button>
				</div>
			</div>

			<mat-option *ngFor="let grade of grades" [value]="grade" [disabled]="!grade.ACTIVE">
				{{grade.GRADES}}: {{grade.DESCRIPTION}}
			</mat-option>
		</mat-select>
	</mat-form-field>
</form>